import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ModelActionsModal } from '@models-global/model-actions';
import * as actions from '@module-claims/store/pharmacy.actions';
import { InhousePharmacyLinkParams } from '@module-claims/models/pharmacy.interface';

export interface IInhousePharmacyModalState {
  readonly action?: ModelActionsModal;
  readonly data?: InhousePharmacyLinkParams;
}

@State<IInhousePharmacyModalState>({
  name: 'InhousePharmacyModalStateState',
  defaults: {
    action: undefined,
    data: undefined
  }
})
@Injectable()
export class InhousePharmacyModalState {
  @Action(actions.InhousePharmacyModalSave)
  saveModal(
    ctx: StateContext<IInhousePharmacyModalState>,
    { params }: actions.InhousePharmacyModalSave
  ): void {
    ctx.patchState({
      action: 'save',
      data: params
    });
  }

  @Action(actions.InhousePharmacyModalClose)
  closeModal(ctx: StateContext<IInhousePharmacyModalState>): void {
    ctx.patchState({
      action: 'close',
      data: undefined
    });
  }
}
